import HttpError from './HttpError'

export default class BadRequestError<T = unknown> extends HttpError {
  // body は親 HttpError 上は unknown 型。型付き取得は jsonApi/useApiEffect の
  // onBadRequest(body: TBad) 経由で行う（declare フィールドは babel 非対応のため使わない）。
  constructor(body: T, response: Response) {
    super(400, body, response)
    this.name = 'BadRequestError'
  }
}
